/** easing */
const SNAPPY_EASE_OUT = 'cubic-bezier(0.0, 0.0, 0.2, 1)';
const SNAPPY_EASE_IN_OUT = 'cubic-bezier(0.4, 0.0, 0.2, 1)';

/** horizontal durations */
export const OPENING_DURATION_HORIZONTAL = 400;
export const CLOSING_DURATION_HORIZONTAL = 350;
export const PANEND_REOPEN_DURATION_HORIZONTAL = 325;
export const PANEND_CLOSE_DURATION_HORIZONTAL = 325;

/** horizontal easing */
export const OPENING_EASING_HORIZONTAL = SNAPPY_EASE_IN_OUT;
export const CLOSING_EASING_HORIZONTAL = SNAPPY_EASE_OUT;
export const PANEND_REOPEN_EASING_HORIZONTAL = SNAPPY_EASE_IN_OUT;
export const PANEND_CLOSE_EASING_HORIZONTAL = SNAPPY_EASE_OUT;

/** vertical durations */
export const OPENING_DURATION_VERTICAL = 500;
export const CLOSING_DURATION_VERTICAL = 450;
export const PANEND_REOPEN_DURATION_VERTICAL = 325;
export const PANEND_CLOSE_DURATION_VERTICAL = 350;

/** vertical easing */
export const OPENING_EASING_VERTICAL = SNAPPY_EASE_IN_OUT;
export const CLOSING_EASING_VERTICAL = SNAPPY_EASE_IN_OUT;
export const PANEND_REOPEN_EASING_VERTICAL = SNAPPY_EASE_IN_OUT;
export const PANEND_CLOSE_EASING_VERTICAL = SNAPPY_EASE_IN_OUT;

/** animation delays */
export const OPENING_DELAY = 100;

/** closing thresholds */
export const CLOSING_RATIO_VERTICAL = 0.2;
export const CLOSING_RATIO_HORIZONTAL = 0.5;
export const CLOSING_VELOCITY_HORIZONTAL = 0.3; // px/ms - same as hammer default, quite sensitive
export const CLOSING_VELOCITY_VERTICAL = 0.5; // has to be higher in the vertical direction since swipes are typically faster, otherwise too sensitive

/** background pan/animation thresholds */
export const MAX_BACKGROUND_BRIGHTNESS = 1;
export const MIN_BACKGROUND_BRIGHTNESS = 0.925;
export const MAX_BACKGROUND_SCALE = 1;
export const MIN_BACKGROUND_SCALE = 0.925;
export const MAX_BACKGROUND_PAN_RATIO_HORIZONTAL = 0.2;

/** misc thresholds */
export const LEFT_EDGE_THRESHOLD = 50;
export const PAN_THRESHOLD = 5;
export const PAN_BUFFER = PAN_THRESHOLD + 15;
export const ANIMATION_COMPLETE_RATIO_VERTICAL = 1; // effectively disabled for now by being set to 1, but can be used to complete the animation at a certain point rather than the full screen dimension
export const BETSLIP_BORDER_RADIUS_CHANGE_THRESHOLD = 3;

/**
 * The delay before touchend triggers panend - a safety measure in case panend doesn't fire,
 * e.g. if children call stopPropagation; it can still be captured by touchend with capture: true.
 * Was set to 50ms in the original implementation but 0 should suffice as it only needs to be async.
 * And there should be the smallest delay possible before panend is handled or the modal will be stuck for a moment.
 */
export const TRIGGER_PANEND_AFTER_TOUCHEND_MS = 0;

/** misc css classes */
export const GESTURE_IS_CLOSING_CLASS = 'gestures-is-closing';
export const EXCLUDED_FROM_GESTURE_SELECTOR = '.gestures-exclude-from-swiping';
export const HORIZONTAL_SCROLL_CONTAINER_SELECTOR = '.scroll-adapter__container';
